<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'parameter-masterdata-page',
};
</script>
